import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import useSignalRPresence from "Common/SingleRConnection/useSignalRPresence";

const SignalRContext = createContext();

export const SignalRProvider = ({ children, unreadMessages }) => {
  const { startPresenceHub } = useSignalRPresence()

  return (
    <SignalRContext.Provider value={{ unreadMessages, startPresenceHub }}>
      {children}
    </SignalRContext.Provider>
  )
}

SignalRProvider.propTypes = {
  children: PropTypes.node.isRequired,
  unreadMessages: PropTypes.number.isRequired,
}

export const useSignalR = () => useContext(SignalRContext)
